import { render, staticRenderFns } from "./selectBox.vue?vue&type=template&id=d8a343e8&scoped=true"
import script from "./selectBox.vue?vue&type=script&lang=js"
export * from "./selectBox.vue?vue&type=script&lang=js"
import style0 from "./selectBox.vue?vue&type=style&index=0&id=d8a343e8&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "d8a343e8",
  null
  
)

export default component.exports